import { Store } from "redux";
import { SeoRenderer } from "../../../../common/helpers/seo";

import loadableComponent from "./loadable";
import { ICh_StateTree } from "../../reducers/interfaces";
import getPosition from "../../reducers/choir/actions/getChoir";

export default {
    component: loadableComponent,
    loadData: ({ dispatch }: Store<ICh_StateTree, any>, path: string) => dispatch(getPosition(path)),
    renderSeo: (_: Store<ICh_StateTree>, allMessage: any, lang: string) => {
        SeoRenderer({
            title: allMessage["choir.preReg.form.title"],
            app: "choir",
            allMessage,
            lang,
        });
    },
};
